import React, { useState } from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";

const BasicPlan = () => {
  const [planDuration, setPlanDuration] = useState("monthly");
  const monthlyPrice = 49.9;

  const calculatePrice = () => {
    if (planDuration === "yearly") {
      const yearlyTotal = monthlyPrice * 12;
      const discountedPrice = yearlyTotal * 0.7; // 70% of the total price (30% discount)
      return discountedPrice.toFixed(2);
    }
    return monthlyPrice.toFixed(2);
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header isHomePage={false} />

      {/* Hero Section */}
      <section className="relative w-full h-[200px] sm:h-[250px] md:h-[300px]">
        <div className="relative w-full h-full">
          <img
            src="/assets/basic-plan.png"
            alt="Basic Plan"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>

        <div className="absolute inset-0 flex items-center justify-start px-4 sm:px-6 md:px-8">
          <h2 className="text-[32px] sm:text-[36px] md:text-[42px] font-medium text-white pl-4 sm:pl-12 md:pl-24 pt-12 sm:pt-24 md:pt-36">
            Temel Paket
          </h2>
        </div>
      </section>

      {/* Plan Content */}
      <section className="w-full px-4 sm:px-6 md:px-6 py-4 sm:py-6 md:py-8">
        {/* Main Card */}
        <div className="w-full bg-white rounded-lg p-4 sm:p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-10 gap-8">
            {/* Left Column - 60% */}
            <div className="col-span-1 md:col-span-6 p-4 sm:p-8 md:p-12">
              <h1 className="text-[32px] sm:text-[36px] md:text-[42px] text-left font-poppins font-bold text-[#242331] mb-3">
                Temel Paket
              </h1>
              <p className="text-[18px] sm:text-[19px] md:text-[21px] font-poppins font-normal text-left leading-relaxed text-[#797979] mb-10">
                Ekibinizle birlikte çalışmanın en temel ve verimli yolu. Tüm
                temel özelliklere erişim sağlayın.
              </p>

              {/* Plan Features */}
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="#00D897" />
                    <path
                      d="M7 12L10.5 15.5L17 9"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="text-[18px] font-poppins text-[#797979]">
                    Temel paketin tüm özellikleri
                  </span>
                </div>
                <div className="flex items-center gap-4">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="#00D897" />
                    <path
                      d="M7 12L10.5 15.5L17 9"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="text-[18px] font-poppins text-[#797979]">
                    10 adete kadar kredi kartı
                  </span>
                </div>
                <div className="flex items-center gap-4">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="#00D897" />
                    <path
                      d="M7 12L10.5 15.5L17 9"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="text-[18px] font-poppins text-[#797979]">
                    Hisse senedi, ETF ve kripto yatırımları
                  </span>
                </div>
                <div className="flex items-center gap-4">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="#00D897" />
                    <path
                      d="M7 12L10.5 15.5L17 9"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="text-[18px] font-poppins text-[#797979]">
                    Premium müşteri desteği
                  </span>
                </div>
              </div>
            </div>

            {/* Right Column - 40% */}
            <div className="col-span-1 md:col-span-4 bg-[#F9F9F9] rounded-3xl p-6 sm:p-8 md:p-12">
              <h2 className="text-[32px] sm:text-[36px] md:text-[42px] text-left font-bold text-[#242331]">
                Plan sürenizi seçin
              </h2>
              <p className="text-[18px] sm:text-[19px] md:text-[21px] leading-relaxed text-gray-600 mb-10 text-left">
                Size en uygun plan süresini seçerek başlayın ve avantajlardan
                hemen yararlanın.
              </p>

              {/* Plan Duration Selector */}
              <div className="mb-10">
                <select
                  className="w-full p-4 bg-white border border-gray-200 rounded-lg text-[15px] text-gray-600 focus:outline-none"
                  value={planDuration}
                  onChange={(e) => setPlanDuration(e.target.value)}
                >
                  <option value="">Plan Süresi Seçin</option>
                  <option value="monthly">Aylık</option>
                  <option value="yearly">Yıllık (%30 indirim)</option>
                </select>
              </div>

              {/* Price */}
              <div className="flex items-baseline gap-1 mb-6">
                <span className="text-4xl font-semibold text-[#242331]">
                  {calculatePrice()}₺
                </span>
                <span className="text-[15px] text-gray-600">
                  / {planDuration === "yearly" ? "yıllık" : "aylık"}
                </span>
              </div>

              {/* CTA Button */}
              <button className="w-full bg-[#E94057] text-white py-4 rounded-lg text-[15px] font-medium hover:bg-[#d63a4f] transition-colors">
                Sepete Ekle
              </button>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-8 p-4 sm:p-12 md:p-24 mx-auto">
          <h2 className="text-[32px] sm:text-[36px] md:text-[42px] font-poppins text-left font-semibold text-[#2F327D] mb-4">
            Temel Plan benim için iyi bir seçim mi?
          </h2>
          <p className="text-[18px] sm:text-[19px] md:text-[21px] text-[#797979] text-left mb-6 max-w-[800px]">
            Temel Plan, dijital varlıklarınızı yönetmeye yeni başlayanlar veya
            bireysel yatırımcılar için ideal bir seçimdir. Bu paket, temel
            finansal işlemlerinizi gerçekleştirmeniz için ihtiyacınız olan tüm
            özellikleri içerir.
          </p>

          <div className="space-y-3">
            <div className="flex items-start gap-2">
              <span className="font-bold text-black text-[16px] sm:text-[18px] md:text-[21px]">
                01.
              </span>
              <span className="text-sm text-[#797979] text-[16px] sm:text-[18px] md:text-[21px] mt-1">
                10 adete kadar kredi kartı yönetimi ile finansal işlemlerinizi
                tek bir yerden kontrol edin
              </span>
            </div>
            <div className="flex items-start gap-2">
              <span className="font-bold text-black text-[16px] sm:text-[18px] md:text-[21px]">
                02.
              </span>
              <span className="text-sm text-[#797979] text-[16px] sm:text-[18px] md:text-[21px] mt-1">
                Hisse senedi, ETF ve kripto para yatırımlarınızı kolayca takip
                edin
              </span>
            </div>
            <div className="flex items-start gap-2">
              <span className="font-bold text-black text-[16px] sm:text-[18px] md:text-[21px]">
                03.
              </span>
              <span className="text-sm text-[#797979] text-[16px] sm:text-[18px] md:text-[21px] mt-1">
                7/24 premium müşteri desteği ile sorularınıza hızlı çözümler
                bulun
              </span>
            </div>
            <div className="flex items-start gap-2">
              <span className="font-bold text-black text-[16px] sm:text-[18px] md:text-[21px]">
                04.
              </span>
              <span className="text-sm text-[#797979] text-[16px] sm:text-[18px] md:text-[21px] mt-1">
                Kullanıcı dostu arayüz ile finansal işlemlerinizi zahmetsizce
                gerçekleştirin
              </span>
            </div>
          </div>

          <p className="text-[18px] sm:text-[19px] md:text-[21px] pt-6 text-[#797979] text-left mb-6 max-w-[800px]">
            Yıllık plan seçeneği ile %30 indirim avantajından yararlanabilir,
            bütçenizi daha verimli kullanabilirsiniz. Temel Plan ile finansal
            hedeflerinize ulaşmak artık çok daha kolay.
          </p>
        </div>
      </section>

      <Footer isHomePage={false} />
    </div>
  );
};

export default BasicPlan;
